var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('row',[_c('loader',{attrs:{"loading":_vm.loading}}),_c('col12',[_c('checkbox',{attrs:{"label":_vm.$t('settings_instances.checkbox'),"value":_vm.instances_enabled},on:{"input":_vm.patch_setting}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }